<template>
  <v-tooltip right content-class="portal-tooltip" v-if="slaColor">
    <template v-slot:activator="{ on }">
      <v-icon :color="slaColor" left v-on="on">notifications_active</v-icon>
    </template>
    <span>{{ slaText }}</span>
  </v-tooltip>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    slaDetail: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    entityState() {
      if (this.slaDetail?.currentEntityState) {
        return this.slaDetail.currentEntityState;
      }
      return null;
    },
    expirationDate() {
      if (this.slaDetail?.expirationDate) {
        return this.slaDetail.expirationDate;
      }
      return null;
    },
    slaType() {
      if (this.slaDetail?.slaEnum) {
        return this.slaDetail.slaEnum;
      }
      return null;
    },
    isRequest() {
      return this.slaType && this.slaType === "APPOINTMENT_REQUEST";
    },
    slaState() {
      if (this.slaDetail?.slaStateEnum) {
        return this.slaDetail.slaStateEnum;
      }
      return null;
    },
    timeToExpirationInDays() {
      if (this.slaDetail?.timeToExpirationInDays) {
        return this.slaDetail.timeToExpirationInDays;
      }
      return 0;
    },
    slaColor() {
      let states = [
        "PENDING",
        "MEMBERCHANGE",
        "APPOINTMENTCANCELLEDBYMEMBER",
        "APPOINTMENTCANCELLEDBYNEST"
      ];
      if (states.includes(this.entityState) && this.slaState === "OK") {
        return "success";
      }
      if (states.includes(this.entityState) && this.slaState === "KO") {
        return "error";
      }
      if (states.includes(this.entityState) && this.slaState === "WARNING") {
        return "warning";
      }
      return "";
    },
    slaText() {
      let expDate = dayjs(this.expirationDate).format("DD/MM/YYYY");
      let days = Number(
        this.timeToExpirationInDays.toString().replace("-", "")
      );
      let reqPos = this.$t("appointments.slaTooltip.request.positive");
      let reqZero = this.$t("appointments.slaTooltip.request.zero");
      let reqNeg = this.$t("appointments.slaTooltip.request.negative");
      let appPos = this.$t("appointments.slaTooltip.appointment.positive");
      let appZero = this.$t("appointments.slaTooltip.appointment.zero");
      let appNeg = this.$t("appointments.slaTooltip.appointment.negative");
      let daysLabel =
        days === 1
          ? this.$t("appointments.slaTooltip.day")
          : this.$t("appointments.slaTooltip.days");
      if (this.timeToExpirationInDays > 0) {
        if (this.isRequest) {
          return `${reqPos} ${expDate}`;
        } else {
          return `${appPos} ${expDate}`;
        }
      }
      if (this.timeToExpirationInDays === 0) {
        if (this.isRequest) {
          return `${reqZero}`;
        } else {
          return `${appZero}`;
        }
      }
      if (this.timeToExpirationInDays < 0) {
        if (this.isRequest) {
          return `${reqNeg} ${days} ${daysLabel}`;
        } else {
          return `${appNeg} ${days} ${daysLabel}`;
        }
      }
      return "";
    }
  }
};
</script>
